module.exports = "https://r.zoocdn.com/_next/static/images/signature2020-0137aa0ae4643a65d0e8f81024d71630.png";